import React from 'react'
import Table from '../table'
import { Column } from 'react-table'
import { WorkPeriodTag } from '../../api/work-period-tags'
import { sortByIgnoreCase } from '../../utils/arrays'
import { Element } from 'react-bulma-components'

interface WorkPeriodTagsListProps {
  data: WorkPeriodTag[]
  onTagClick: (tag: WorkPeriodTag) => void
}

/**
 * Component that displays a table of work period tags
 */
const WorkPeriodTagsList: React.FC<WorkPeriodTagsListProps> = ({ data, onTagClick }) => {
  const tableColumns = useListTableColumns(onTagClick)

  return (
    <Table
      columns={tableColumns}
      data={sortByIgnoreCase<WorkPeriodTag>(data, 'name')}
      noDataMessage="Aucune catégorie à afficher"
      dataTest="work-period-tags-list"
    />
  )
}

const useListTableColumns = (
  onTagClick?: WorkPeriodTagsListProps['onTagClick'],
): Column<WorkPeriodTag>[] => {
  return React.useMemo(
    () => [
      {
        Header: 'Nom',
        accessor: 'name',
        Cell: data => (
          <Element
            renderAs="a"
            color="ghost"
            onClick={() => onTagClick?.(data.row.original)}
            data-test={`work-period-tag-${data.row.original._id}-link`}
          >
            {data.row.original.name}
          </Element>
        ),
      },
    ],
    [onTagClick],
  )
}

export default WorkPeriodTagsList
